import { Checkbox, DefaultButton, PrimaryButton, TextField, ChoiceGroup } from "@fluentui/react";
import React, { useCallback, useEffect, useContext } from "react";
import { getEnv } from '../../../../helpers/EnvHelper';
import { t } from "i18next";
import MobileInput from "../../../../components/MobileInput";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";
import themeContext from "../../../../context/theme/ThemeContext";
import userContext from "../../../../context/users/UserContext";
import { choiceGroupStyles } from "../../helpers/Styles";

const UserDetailsSection = (props) => {
  let isEnableWhatsApp =   (getEnv("REACT_APP_ENABLE_WHATSAPP") == "true" || getEnv("REACT_APP_ENABLE_WHATSAPP") == true) ? true : false;
  const { themeName, getThemeColor } = useContext(themeContext);
  const { roles } = useContext(userContext);
  const viewerRole = roles?.[0];

  const setMobileError = (e) => {
    if(e == null){
      props.setCustomMobileError(null);
    }
    props.setCustomMobileError(e);
  }

  const handleInputValidationMobile = (inputNumber,country) => {
    let targetLength = country.format.match(/\./g).length;
    let fixedLength = targetLength - country.dialCode.length;
    let inputTargetLength =
      inputNumber.length - country.dialCode.length;
      console.log("--- Mobile Field Values ---",inputNumber,targetLength,fixedLength,inputTargetLength,country);
    if (
      inputTargetLength != fixedLength &&
      inputNumber.length > country.dialCode.length &&
      !(inputNumber.length >= 10 && fixedLength > 10)
    ) {
        console.log("--- Error in validation mobile field ---");
        props.setCustomMobileError("For " + country.name + " (" + fixedLength + " digits required)");
        return;
    }
    if (
      (inputTargetLength == 0 || inputNumber.length < 2 )
    ) {
        console.log("---- Error mobile field empty ----");
          setTimeout(()=>{
            props.setCustomMobileError("Mobile cannot be blank");
          },100);     
        return;
    }
      console.log("---- No error in mobile field -----");
      setTimeout(()=>{
        props.setCustomMobileError(null);
      },100);
  }
  useEffect(() => {
  if (!isEnableWhatsApp) {
    console.log("[GlobalFlag][UserDetails] WhatsApp disabled globally");

    // Force Formik state
    props.setFieldValue("enableWhatsApp", false, false);
    props.setFieldValue("whatsappNumber", "", false);

  }
}, []);

 useEffect(() => {
  if (props.userType === USERTYPES.ADMIN) return; // ADMIN always allowed regardless of parent flags
  if ((!isEnableWhatsApp || !props.whatsappParentEnabled) && props.values.enableWhatsApp) {
    props.setFieldValue("enableWhatsApp", false);
    props.setFieldValue("whatsappNumber", "");
  }
}, [isEnableWhatsApp,props.whatsappParentEnabled]); // runs when gate changes

  // Gate Email (NEW – mirror WhatsApp)
  useEffect(() => {
    if (props.userType === USERTYPES.ADMIN) return; // ADMIN always allowed regardless of parent flags
    if (!props.emailParentEnabled && props.values.enableEmail) {
      props.setFieldValue("enableEmail", false);
      // clear the email input when disabled:
      // props.setFieldValue("email", "");
    }
  }, [props.emailParentEnabled]);

   // ---------- show errors on touched OR after submit ----------
  const submitCount = props.submitCount || 0;
  
  // error attached by Yup .test() (we attach createError path "enableEmail")
  const showChooseOneError = !!props.errors?.enableEmail && ((props.touched?.enableEmail || props.touched?.enableWhatsApp) ||submitCount > 0);

  // notification/email field error (show on touch or submit)
  const showNotificationEmailError =
    !!props.errors?.email && (props.touched?.email || submitCount > 0);

  // whatsapp number error (show on touch or submit)
  const showWhatsAppNumberError =
    !!props.errors?.whatsappNumber && (props.touched?.whatsappNumber || submitCount > 0);

    // Helper: is the channel forced ON by firm policy?
  const emailForced = props.emailParentEnabled && !props.whatsappParentEnabled;
  const whatsappForced = props.whatsappParentEnabled && !props.emailParentEnabled;

  // Checkboxes are always clickable; validation will error on save if mandatory channel is unchecked
  const emailCheckboxDisabled = false;
  const whatsappCheckboxDisabled = false;

  // When a checkbox is un-checked by user, clear its input (optional but helpful)
  const onToggleEmail = (ev, checked) => {
    props.setFieldValue("enableEmail", !!checked);
    if (!checked) props.setFieldValue("email", "");
  };

  const onToggleWhatsApp = (ev, checked) => {
    props.setFieldValue("enableWhatsApp", !!checked);
    if (!checked) props.setFieldValue("whatsappNumber", "");
  };
  return (
    <>
      {(props.state.action === ACTIONS.ADD || props.state.action === ACTIONS.EDIT) &&
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("user.user-details")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">

            <div className="ms-Grid-row">
              <TextField
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                name="firstName"
                placeholder={t("user.first-name")}
                label={t("user.first-name")}
                onChange={props.handleChange}
                value={props.values.firstName}
                onBlur={props.handleBlur}
                errorMessage={props.touched.firstName && props.errors.firstName}
              />

              <TextField
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                name="lastName"
                placeholder={t("user.last-name")}
                label={t("user.last-name")}
                onChange={props.handleChange}
                value={props.values.lastName}
                onBlur={props.handleBlur}
                errorMessage={props.touched.lastName && props.errors.lastName}
              />
            </div>
            {props.userType === USERTYPES.RADIOLOGIST &&
              (viewerRole === USERTYPES.ADMIN ||
                viewerRole === USERTYPES.FIRMADMIN) && (
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <TextField
                  name="specialist"
                  placeholder={t("user.specialist-placeholder")}
                  label={t("user.specialist")}
                  onChange={props.handleChange}
                  value={props.values.specialist ?? ""}
                  onBlur={props.handleBlur}
                  errorMessage={
                    props.touched.specialist && props.errors.specialist
                  }
                />
                </div>
              </div>
            )}
            {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <TextField
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                name="email"
                placeholder={t("user.email")}
                label={t("user.email")}
                onChange={props.handleChange}
                value={props.values.email}
                onBlur={props.handleBlur}
                errorMessage={props.touched.email && props.errors.email}
              />
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <MobileInput
                  name={`mobile`}
                  value={props.values.mobile}
                  label={t("user.mobile")}
                  onChangeCustom={(value, data) => {
                    handleInputValidationMobile(value,data);
                    const event = { target: { name: "mobile", value: "+" + value } };
                    props.handleChange(event);
                    props.values.mobile = "+" + value;
                  }}
                  touched={props.touched.mobile}
                  errorMessage={setMobileError}
                />
              </div>
            </div> */}
            {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <TextField
                className={
                  "form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                }
                name="username"
                placeholder={t("user.username")}
                label={t("user.username")}
                autoComplete="off"
                onChange={props.handleChange}
                value={props.values.username}
                onBlur={props.handleBlur}
                errorMessage={props.touched.username && props.errors.username}
                readOnly={props.state.action === ACTIONS.EDIT}
              />

            </div> */}
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <MobileInput
                  name={`mobile`}
                  value={props.values.mobile}
                  label={t("user.mobile")}
                  onChangeCustom={(value, data) => {
                    handleInputValidationMobile(value,data);
                    const event = { target: { name: "mobile", value: "+" + value } };
                    props.handleChange(event);
                    props.values.mobile = "+" + value;
                  }}
                  touched={props.touched.mobile}
                  errorMessage={setMobileError}
                />
              </div>
              {/* <TextField
                className={"form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"}
                  name="username"
                  placeholder={t("user.username")}
                  label={t("user.username")}
                  autoComplete="off"
                  onChange={props.handleChange}
                  value={props.values.username}
                  onBlur={props.handleBlur}
                  errorMessage={props.touched.username && props.errors.username}
                  readOnly={props.state.action === ACTIONS.EDIT}
                /> */}
              </div>
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                  <TextField
                //className={"form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"}
                  name="username"
                  placeholder={t("user.username")}
                  label={t("user.username")}
                  autoComplete="off"
                  onChange={props.handleChange}
                  value={props.values.username}
                  onBlur={props.handleBlur}
                  errorMessage={props.touched.username && props.errors.username}
                  readOnly={props.state.action === ACTIONS.EDIT}
                />
                </div>
                </div>
              {/* {(props.emailParentEnabled || props.values.enableEmail) && (
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg2 ms-xl2">
                  <Checkbox
                    //label="Enable Email"
                    label={<span style={{ color: "#fff", fontWeight: 600, fontSize: 14 }}>Enable Email</span>}
                    checked={!!props.values.enableEmail}
                    // onChange={(_, checked) => {
                    //   props.setFieldValue("enableEmail", !!checked);
                    //   // optional clear:
                    //   // if (!checked) props.setFieldValue("email", "");
                    //   props.validateField && props.validateField("enableEmail");
                    // }}
                   onChange={onToggleEmail}
                   disabled={emailCheckboxDisabled}


                  />
                </div>

              {props.values.enableEmail && (
                <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4" style={{marginTop:"8px"}}>
                  <TextField
                    // className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3"
                    name="email"
                    placeholder={t("user.email")}
                    //label={t("user.email")}
                    //onChange={props.handleChange}
                    value={props.values.email}
                    onChange={(e, newVal) => props.setFieldValue("email", newVal)}
                    //onBlur={props.handleBlur}
                    //errorMessage={props.touched.email && props.errors.email}
                    errorMessage={showNotificationEmailError ? props.errors.email : undefined}

                  />
                  </div>
                )}
              </div>
            )} */}
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              {/* PASSWORD NOT TO BE SHOWN ON EDIT PAGE */}
              {props.state.action === ACTIONS.ADD && (
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  name="password"
                  placeholder={t("user.password")}
                  type="password"
                  label={t("user.password")}
                  autoComplete="off"
                  canRevealPassword
                  onChange={props.handleChange}
                  value={props.values.password}
                  onBlur={props.handleBlur}
                  errorMessage={
                    props.touched.password && props.errors.password
                  }
                />
              )}
              {/* CONFIRM PASSWORD NOT TO BE SHOWN ON EDIT PAGE */}
              {props.state.action === ACTIONS.ADD && (
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  name="confirmPassword"
                  placeholder={t("user.confirm-password")}
                  type="password"
                  label={t("user.confirm-password")}
                  autoComplete="off"
                  canRevealPassword
                  onChange={props.handleChange}
                  value={props.values.confirmPassword}
                  onBlur={props.handleBlur}
                  errorMessage={
                    props.touched.confirmPassword &&
                    props.errors.confirmPassword
                  }
                />
              )}
            </div>
              {(props.values.username == 'dtadmin' || props.emailParentEnabled || props.userType === USERTYPES.ADMIN) && (
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg2 ms-xl2">
                  <Checkbox
                    label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable Email</span>}
                    checked={!!props.values.enableEmail}
                   onChange={onToggleEmail}
                   disabled={emailCheckboxDisabled}
                  />
                </div>

              {props.values.enableEmail && (
                <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4" style={{marginTop:"8px"}}>
                  <TextField
                    name="email"
                    placeholder={t("user.email")}
                    value={props.values.email}
                    onChange={(e, newVal) => props.setFieldValue("email", newVal)}
                    errorMessage={showNotificationEmailError ? props.errors.email : undefined}
                  />
                  </div>
                )}
              </div>
            )}
            {/* --- Enable WhatsApp + Number (below passwords) --- */}
            {isEnableWhatsApp && (props.values.username == 'dtadmin' || props.whatsappParentEnabled || props.userType === USERTYPES.ADMIN) && (
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg2 ms-xl2">
                <Checkbox
                  label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>Enable WhatsApp</span>}
                  checked={!!props.values.enableWhatsApp}
                  onChange={onToggleWhatsApp}
                  disabled={whatsappCheckboxDisabled}
                />
              </div>

              {props.values.enableWhatsApp && (
                <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <MobileInput
                    name="whatsappNumber"
                    //label={ "WhatsApp Number"}
                    value={props.values.whatsappNumber || ""}
                    onBlurCustom={() =>
                      props.handleBlur({ target: { name: "whatsappNumber" } })
                    }
                     onChangeCustom={(value) => {
                      // Normalize to E.164-like: ensure leading '+'
                      if (value && !value.startsWith("+")) value = "+" + value;
                      props.setFieldValue("whatsappNumber", value);
                    }}
                    touched={props.touched.whatsappNumber}
                    // errorMessage={
                    //   props.touched.whatsappNumber && props.errors.whatsappNumber
                    // }
                    // errorMessage={
                    // props.errors.whatsappNumber && (props.touched.whatsappNumber || props.submitCount > 0)
                    // ? props.errors.whatsappNumber 
                    // : undefined
                    // }
                  />
                  {props.errors.whatsappNumber && (props.touched.whatsappNumber || props.submitCount > 0) && (
                    <div style={{ color: "red", fontSize: "12px", marginTop: "5px",fontWeight: 700, fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif' }}>
                    {props.errors.whatsappNumber}
                  </div>
                  )}
                </div>
              )}
            </div>
            )}
            {showChooseOneError && (
              <div className="ms-Grid-row" style={{ marginTop: "8px" }}>
                <div className="ms-Grid-col ms-sm12" style={{ color: "red", fontSize: "12px", fontWeight: "700", fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif' }}>
                  {emailForced ? "Email cannot be blank." : whatsappForced ? "Number cannot be blank." : "Choose either Email or WhatsApp (or both)."}
                </div>
              </div>
            )}
          </div>
                  {(props.state.action === ACTIONS.ADD ) && (
                  <div className="ms-Grid-row single-line-form-field" style={{ marginTop: "20px" ,marginLeft: "0px"}}>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl3 single-line-form-field-value">
                            <p className="single-line-form-field-key">
                              {/* {t("user.send-study-assign-mail")} */}
                              {t("user.send-welcome-notification")}
                            </p>
                          </div>
                    <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                              <Checkbox
                                defaultChecked={props.values.sendWelcomNotification}
                                //value={props.values.sendWelcomNotification}
                                styles={choiceGroupStyles}
                                onChange={() => {
                                  props.values.sendWelcomNotification =
                                    !props.values.sendWelcomNotification;
                                }}
                              />
                          </div>
                      
                        </div>
                      )}
                   
        </div>
      }
      {props.state.action === ACTIONS.VIEW &&
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("user.user-details")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.first-name")}</div>
                <div className="form-mt-10">{props.values.firstName}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.last-name")}</div>
                <div className="form-mt-10">{props.values.lastName}</div>
              </div>
            </div>
            {props.userType === USERTYPES.RADIOLOGIST && (
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                  <div className="form-heading">{t("user.specialist")}</div>
                  <div className="form-mt-10">
                    {props.values.specialist && props.values.specialist.trim()
                      ? props.values.specialist
                      : "-"}
                  </div>
                </div>
              </div>
            )}
            {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.email")}</div>
                <div className="form-mt-10">{props.values.email}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.mobile")}</div>
                <div className="form-mt-10">{props.values.mobile}</div>
              </div> 
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                <div className="form-heading">{t("user.username")}</div>
                <div className="form-mt-10">{props.values.username}</div>
              </div>
            </div> */}
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.mobile")}</div>
                <div className="form-mt-10">{props.values.mobile}</div>
              </div> 
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                <div className="form-heading">{t("user.username")}</div>
                <div className="form-mt-10">{props.values.username}</div>
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                {getEnv("REACT_APP_ENTERPRISE_PLATFORM") === "false" &&
                    <div className="form-heading">{props.userType === USERTYPES.FIRMADMIN ? t("user.firm-code"):t("user.code")}</div>
                }
                {getEnv("REACT_APP_ENTERPRISE_PLATFORM") === "true" &&
                    <div className="form-heading">{props.userType === USERTYPES.FIRMADMIN ? t("user.hospital-code"):t("user.code")}</div>
                }
                <div className="form-mt-10">{props.userType === USERTYPES.FIRMADMIN ? props.values.firmCode:props.values.code }</div>
              </div>
            </div>
            {(props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN) && 
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                  <div className="form-heading">{getEnv("REACT_APP_ENTERPRISE_PLATFORM") === "false"? t("user.firm"):t("user.hospital")}</div>
                  <div className="form-mt-10">{props.values.firmName}</div>
                </div>
              </div>
            }
              {/* Email summary (view) */}
              {props.emailParentEnabled && props.values.enableEmail && (
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                <div className="form-heading">Enable Email</div>
                <div className="form-mt-10">
                  {props.values.enableEmail ? "Yes" : "No"}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                <div className="form-heading">{t("user.email")}</div>
                <div className="form-mt-10">
                  {props.values.enableEmail ? (props.values.email || "-") : "-"}
                </div>
              </div>
            </div>
              )}
              {isEnableWhatsApp && props.whatsappParentEnabled && props.values.enableWhatsApp && (
              <div className="ms-Grid-row" style={{ alignItems: "center", marginTop: 20 }}>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                <div className="form-heading">Enable WhatsApp</div>
                <div className="form-mt-10">
                  {props.values.enableWhatsApp ? "Yes" : "No"}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                <div className="form-heading">WhatsApp Number</div>
                <div className="form-mt-10">
                  {props.values.enableWhatsApp ? (props.values.whatsappNumber || "-") : "-"}
                </div>
              </div>
            </div>
            )}
            
          </div>
        </div>
      }
    </>
  )
};

export default UserDetailsSection;